/**
 * Safe relative returnPath for Platform Hub login (must match backend hubReturnPath rules).
 */
export function sanitizeHubReturnPath(input?: string | null, fallback = '/dashboard'): string {
  let raw = String(input || '').trim();
  if (!raw) return fallback;

  if (raw.includes('://') || raw.startsWith('//')) {
    try {
      const normalized = raw.startsWith('//') ? `https:${raw}` : raw;
      const u = new URL(normalized);
      raw = `${u.pathname || '/'}${u.search || ''}${u.hash || ''}`;
    } catch {
      return fallback;
    }
  }

  if (!raw.startsWith('/')) raw = `/${raw}`;
  if (raw.startsWith('//') || raw.includes('://')) return fallback;

  const pathOnly = raw.split('?')[0].split('#')[0];
  if (
    pathOnly === '/auth/sso' ||
    pathOnly === '/auth/callback' ||
    pathOnly === '/login' ||
    pathOnly === '/register'
  ) {
    return fallback;
  }

  return raw || fallback;
}
